import { useTranslation } from 'react-i18next';
import ModalFrame from '../../../ui/primitives/ModalFrame';
import { getDecorImagePath } from '../../../data/mapDecorAssets';

interface WinstonCatModalProps {
  isOpen: boolean;
  onClose: () => void;
}

/** Winston Churchill Cat monument lore modal. */
export default function WinstonCatModal({ isOpen, onClose }: WinstonCatModalProps) {
  const { t } = useTranslation();

  return (
    <ModalFrame
      isOpen={isOpen}
      onClose={onClose}
      variant="dialog"
      className="max-w-[400px]"
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}>
        <img
          src={getDecorImagePath('decor_monument_cat_winston_churchill')}
          alt={t("Winston Churchill Cat Statue")}
          style={{
            width: 'auto',
            height: 'auto',
            maxWidth: '100%',
            borderRadius: '12px',
          }}
        />
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', textAlign: 'center' }}>
          <div style={{ fontSize: '18px', fontWeight: 600, color: '#fff' }}>
            {t("🐱 Statue of Winston Churchill Cat")}
          </div>
          <div style={{ fontSize: '14px', lineHeight: '1.6', color: '#E0E0E0' }}>
            {t("They say this cat was never a mayor. But all mayors consulted with him. He didn't fight wars — he simply survived them all.")}
          </div>
          <div style={{ fontSize: '14px', lineHeight: '1.6', color: '#E0E0E0' }}>
            {t("If the island still stands, perhaps it's because someone always watched over the map from the height of feline wisdom.")}
          </div>
        </div>
      </div>
    </ModalFrame>
  );
}
